import React from "react";

const PrivacyPolicyText = () => (
  <div>
    <h1 style={{ marginBottom: '4vw', textAlign: 'center', fontSize: "4vw", fontFamily: "NewZen-Bold", fontWeight: 400 }}>Crossed Paths Privacy Policy</h1>
    
    <p style={{ marginBottom: '4vw', fontSize: "3vw", fontFamily: "NewZen", fontWeight: 400 }}>Welcome to the Crossed Paths Privacy Policy (“Policy”) page.</p>
    <p style={{ marginBottom: '4vw', fontSize: "3vw", fontFamily: "NewZen", fontWeight: 400 }}>
      The information you can read here explains how we collect, store, protect, and
      share your information, and with whom we share it. We suggest you read this
      in conjunction with our Terms and Conditions of Use.
    </p>
    <p style={{ marginBottom: '4vw', fontSize: "3vw", fontFamily: "NewZen", fontWeight: 400 }}>
      Whilst you’re enjoying the Crossed Paths mobile application (including the
      desktop version) (“App”), our websites and microsites (such as crossed-paths.online) or using our digital products and services (such as our
      competitions or surveys) (together, referred to in this Privacy Policy as our
      “Sites”), we collect some information about you. In addition, you may choose
      to use the App or Sites to share information with other users, including your
      friends and contacts (“Users”). We may also need to share your information
      sometimes.
    </p>
    <p style={{ marginBottom: '4vw', fontSize: "3vw", fontFamily: "NewZen", fontWeight: 400 }}>
      The App and Sites are global, and your information can be sent to and used in
      the United States and the UK regardless of the country you reside in. This
      Policy explains how we protect your personal data when we transfer it
      overseas, so please read very carefully!
    </p>
    
    <h2 style={{ marginBottom: '4vw', fontSize: "3.4vw", fontFamily: "NewZen", fontWeight: 600 }}>Who we are</h2>
    <p style={{ marginBottom: '4vw', fontSize: "3vw", fontFamily: "NewZen", fontWeight: 400 }}>
      The App and Sites are operated by DATAMORPHOSIS SRL (also referred to in
      this policy as “we” or “us”) as the controllers of personal information collected
      and processed through the Crossed Paths App and Sites.
    </p>
    <p style={{ marginBottom: '4vw', fontSize: "3vw", fontFamily: "NewZen", fontWeight: 400 }}>
      The Crossed Paths has designated a Data Protection Officer and they can be
      reached by emailing DPO@crossed-paths.online.
    </p>
    
    <h3 style={{ marginTop: '4vw', fontSize: "3.4vw", fontFamily: "NewZen", fontWeight: 600 }}>1. COLLECTION OF INFORMATION</h3>
    
    <h4 style={{  fontSize: "3.3vw", fontFamily: "NewZen", fontWeight: 600 }}>Registration Information</h4>
    <p style={{ fontSize: "3vw", fontFamily: "NewZen", fontWeight: 400 }}>
      When you download the App and create an account (“Account”), we may
      collect certain information (“Registration Information”) about you, such as:
    </p>
    <ul style={{ marginBottom: '4vw', fontSize: "3vw", fontFamily: "NewZen", fontWeight: 400 }}>
      <li>Name;</li>
      <li>Username;</li>
      <li>Email address;</li>
      <li>Gender identity;</li>
      <li>Date of birth;</li>
      <li>Sexual preference;</li>
      <li>Photographs;</li>
      <li>Location; and</li>
      <li>Login information for accounts used to connect to your Crossed Paths
        Account (this could include, for example, your Google account). For more
        information about this, see “Linking other Accounts to Crossed Paths” in
        section 7 below.
      </li>
    </ul>
    <p style={{ marginBottom: '4vw', fontSize: "3vw", fontFamily: "NewZen", fontWeight: 400 }}>
      Once you register, you will be able to review and change this information at
      any time just by logging in to Crossed Paths (other than your date of birth and
      location (which, if you have given Crossed Paths access to your location in
      your device settings, is automatically updated based on the location of your
      device)). It is your responsibility to ensure that your account details are kept
      up to date.
    </p>
    <p style={{ marginBottom: '4vw', fontSize: "3vw", fontFamily: "NewZen", fontWeight: 400 }}>
      The information we collect helps to enhance the App and verify our Users
      (robots are not welcome!). Registration Information such as your sexual
      preference, name and username may be visible to other Users who view your
      profile page.
    </p>
    <p style={{ marginBottom: '4vw', fontSize: "3vw", fontFamily: "NewZen", fontWeight: 400 }}>
      For Users who are California residents, the data we may collect falls within the
      following categories of “personal information,” as defined by the California
      Consumer Privacy Act (CCPA):
    </p>
    <ul  style={{ marginBottom: '4vw', fontSize: "3vw", fontFamily: "NewZen", fontWeight: 400 }}>
      <li>Identifiers, such as name and location;</li>
      <li>Personal information, as defined in the California customer records law,
        such as contact (including email and telephone number) and financial
        information;
      </li>
      <li>Characteristics of protected classifications under California or federal law (if
        you choose to provide them), such as age, gender identity, marital status,
        sexual orientation, race, ancestry, national origin, religion, and medical
        conditions;
      </li>
      <li>Commercial information, such as transaction information and purchase
        history;
      </li>
      <li>Biometric information;</li>
      <li>Internet or network activity information, such as browsing history and
        interactions with our Sites and App;
      </li>
      <li>Geolocation data, such as mobile device location;</li>
      <li>Audio, electronic, visual and similar information, such as photos and videos;</li>
      <li>Professional or employment-related information, such as work history and
        prior employer;
      </li>
      <li>Non-public education information; and</li>
      <li>Inferences drawn from any of the personal information listed above to
        create a profile or summary about, for example, an individual’s preferences
        and characteristics.
      </li>
    </ul>
    
    <h4 style={{  fontSize: "3.3vw", fontFamily: "NewZen", fontWeight: 600 }}>Profile Information</h4>
    <p style={{ marginBottom: '4vw', fontSize: "3vw", fontFamily: "NewZen", fontWeight: 400 }}>
      We recommend and encourage you (and all our members) to think carefully
      about the information you disclose about yourself. We also do not
      recommend that you put email addresses, URLs, instant messaging details,
      phone numbers, full names or addresses, credit card details, national identity
      numbers, drivers’ license details and other sensitive information which is open
      to abuse and misuse on your profile.
    </p>
    <p style={{ marginBottom: '4vw', fontSize: "3vw", fontFamily: "NewZen", fontWeight: 400 }}>
      When you post information about yourself or use the messaging function to
      communicate with other Users, the amount of personal information you share
      is at your own risk. Please see Section 4 below for more information on who
      can access what you post on Crossed Paths.
    </p>
    
    <h4 style={{  fontSize: "3.3vw", fontFamily: "NewZen", fontWeight: 600 }}>Profile Verification Information (Including Biometric Information)</h4>
    <p style={{ marginBottom: '4vw', fontSize: "3vw", fontFamily: "NewZen", fontWeight: 400 }}>
      For safety and security and to ensure you have the best possible user
      experience, we require Users to verify their accounts and might ask that you
      carry out photo verification. We want to make sure you are not a robot! And
      we also want to avoid fake Crossed Paths accounts being created which can
      be used for malicious activities and cybercrime – they threaten the Crossed
      Paths network and spoil things for everyone. This verification might be
      required by us for the prevention of fraud. You can also verify your photo on
      a voluntary basis (to add the blue ‘verified’ badge to your profile).
    </p>
    <p style={{ marginBottom: '4vw', fontSize: "3vw", fontFamily: "NewZen", fontWeight: 400 }}>
      If you choose to verify your profile photo, we will scan each photo that you
    </p>
    <h2 style={{ marginBottom: '4vw', fontSize: "3.4vw", fontFamily: "NewZen", fontWeight: 600 }}>Profile Photo Rearrangement</h2>
<p style={{ marginBottom: '4vw', fontSize: "3vw", fontFamily: "NewZen", fontWeight: 400 }}>
  We may use that data to rearrange your profile photos aiming to position them in a way that is favorable to you. You may opt-out of this feature through our app settings.
</p>

<h2 style={{ marginBottom: '4vw', fontSize: "3.4vw", fontFamily: "NewZen", fontWeight: 600 }}>Links</h2>
<p style={{ marginBottom: '4vw', fontSize: "3vw", fontFamily: "NewZen", fontWeight: 400 }}>
  We may keep track of how you interact with links available on Crossed Paths including third-party services by redirecting clicks or through other means. We may share aggregate click statistics such as how many times a particular link was clicked on.
</p>

<h2 style={{ marginBottom: '4vw', fontSize: "3.4vw", fontFamily: "NewZen", fontWeight: 600 }}>Messages</h2>
<p style={{ marginBottom: '4vw', fontSize: "3vw", fontFamily: "NewZen", fontWeight: 400 }}>
  We review the content of messages sent in the App to identify topics, sentiments, and trends across our Users. We will take steps to vwove personally identifying information from such messages, prior to reviewing them. We will not share the content of User messages or information we derive from them with any third party.
</p>

<h2 style={{ marginBottom: '4vw', fontSize: "3.4vw", fontFamily: "NewZen", fontWeight: 600 }}>Crossed Paths Success Stories, Surveys and other Contributions</h2>
<p style={{ marginBottom: '4vw', fontSize: "3vw", fontFamily: "NewZen", fontWeight: 400 }}>
  From time to time, we run surveys for research purposes and we may contact you to find out if you would like to take part. We may also contact you to find out if you would like to provide feedback, a testimonial, or take part in marketing campaigns (for example, if you let us know that you have found a match on the App, we may contact you to ask if you would be happy to feature in advertising for Crossed Paths). Such surveys and marketing campaigns are optional and more information will be provided at the point of contact. If you do not wish to be contacted to take part in surveys or marketing campaigns, please contact our Customer Support Team via our Feedback Page.
</p>

<h2 style={{ marginBottom: '4vw', fontSize: "3.4vw", fontFamily: "NewZen", fontWeight: 600 }}>When you Contact Customer Support</h2>
<p style={{ marginBottom: '4vw', fontSize: "3vw", fontFamily: "NewZen", fontWeight: 400 }}>
  If you contact our Customer Support team via our Feedback Page, we will receive your email address and may track your IP address, as well as the information you send to us to help resolve your query. We will keep records of our communications with you, including any complaints that we receive from you about other Users (and from other Users about you) for 6 years after deletion of your account.
</p>

  </div>
);

export default PrivacyPolicyText;
